export const comments_4322230 = {"data":{"data":[],"links":{}}}